/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_NavInputs */

const en_hub_nav = /** @type {(inputs: Hub_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training`)
};

const pl_hub_nav = /** @type {(inputs: Hub_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening`)
};

/**
* | output |
* | --- |
* | "Training" |
*
* @param {Hub_NavInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hub_nav = /** @type {((inputs?: Hub_NavInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_NavInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hub_nav(inputs)
	return en_hub_nav(inputs)
});